import React from 'react';
import PropTypes from 'prop-types';
import DetailGeneralInfo from '../../DetailGeneralInfo';

const Schedule = ({ value }) => {
  return <DetailGeneralInfo data={value}>Schedule</DetailGeneralInfo>;
};

export default Schedule;

Schedule.propTypes = {
  value: PropTypes.object,
};
